export default defineNuxtPlugin((nuxtApp) => {
  const translate = nuxtApp.$translate as (key: string) => string
  return { 
    provide: {
      convertToHoursAndMinutes: (s: string): string => {
        const re = new RegExp(' ' + translate('min') + '$')
        if (!s.match(re)) {
          return s
        }
        const minuteArr = s.match(/^[0-9]+/)
        if (!minuteArr) return s

        const minutes = parseInt(minuteArr[0])
        const hours = Math.floor(minutes / 60)
        const remainder = minutes % 60

        return (hours > 0 ? hours + ' ' + translate('h') : '') + 
              (hours > 0 && remainder > 0 ? ' ' : '') + 
              (remainder > 0 ? remainder + ' ' + translate('min') : '')
      }
    }
  }
})